import { LinearProgress, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetPetMedicalOverview } from "../../../../../../hooks/useGetPetMedicalOverview";
import HealthSummary from "./medicalOverview/HealthSummary";
import TreatmentDetailsSummary from "./medicalOverview/TreatmentDetailsSummary";

export default function MedicalOverview() {
  const { t } = useTranslation();
  const { id: petId } = useParams();

  const { data, isLoading, error } = useGetPetMedicalOverview(petId);

  if (isLoading) {
    return <LinearProgress />;
  } else if (error) {
    return <Typography color="error">{t("ErrorFetchingMedicalSummary")}</Typography>;
  }

  return (
    <Stack spacing={2}>
      <HealthSummary data={data} />
      <TreatmentDetailsSummary data={data} />
    </Stack>
  );
}
